<template>
  <div class="application">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="applicationlist">
        <div
          class="applicationlistItem"
          v-for="item in applicationlist"
          :key="item.id"
          @click="goRegistration(item)"
        >
          <div class="img_left">
            <img src="" v-lazy="$global.imgUrl + item.cover" alt="" />
            <img
              class="img_img"
              src="@/assets/mylogin/slices/notStarted.png"
              alt=""
              v-if="item.timeStatus === '未开始'"
            />
            <img
              class="img_img"
              src="@/assets/mylogin/slices/finished.png"
              alt=""
              v-if="item.timeStatus === '已结束'"
            />
            <img
              class="img_img"
              src="@/assets/mylogin/inMeeting.png"
              alt=""
              v-if="item.timeStatus === '会议中'"
            />
          </div>
          <div class="cent_right">
            <h3>{{ item.title }}</h3>
            <div class="qing">
              <span>{{ item.province }}-{{ item.city }}</span>
              <span>{{ relatedMeetingTime(item.beginTime) }}</span>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
export default {
  name: "application",
  data() {
    return {
      loading: false,
      finished: false,
      error: false,
      applicationlist: [],
      pageNo: 0,
      pageSize: 20,
    };
  },
  computed: {
    // 相关会议的开始时间
    relatedMeetingTime() {
      return function (endTime) {
        if (endTime) {
          return this.$global.formatDateDrop(endTime, false);
        }
      };
    },
  },
  methods: {
    goRegistration(item) {
      this.$router.push({
        path: "/registration",
        query: { item: JSON.stringify(item) },
      });
    },
    onLoad() {
      this.pageNo += 1;
      this.getapplication();
    },
    async getapplication() {
      const res = await this.$apis.myServe.getapplicationList({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      });
      if (res.resultCode == 200) {
        console.log(res);
        this.finished = res.data.list.length < 20;
        this.applicationlist.push(...res.data.list);
      } else {
        this.error = true;
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.application {
  width: 100vw;
  min-height: 100vh;
  background: #f5f5f5;

  .applicationlist {
    margin: 0 auto;
    width: 351px;
    border-radius: 8px;
    background-color: #fff;

    .applicationlistItem {
      display: flex;
      padding: 15px 12px;
      width: 100%;
      border-bottom: 1px solid #eeeeee;
      &:last-child {
        border-bottom: none;
      }

      .img_left {
        position: relative;
        flex: none;
        width: 130px;
        height: 73px;
        border-radius: 8px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }

        .img_img {
          position: absolute;
          top: 0px;
          left: 0px;
          width: 45px;
          height: 20px;
        }
      }

      .cent_right {
        margin-left: 10px;
        h3 {
          font-size: 15px;
          color: #333333;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }

        .qing {
          display: flex;
          justify-content: space-between;
          margin-top: 14px;

          span {
            font-size: 12px;
            color: #999999;
          }
        }
      }
    }
  }
}
</style>
